/* tslint:disable */
/* eslint-disable */
/**
 * VWN Video streaming service docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.2.7-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    corporation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    admin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    organiser?: boolean;
}

/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value: object): value is UserDto {
    return true;
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'givenName': json['givenName'] == null ? undefined : json['givenName'],
        'familyName': json['familyName'] == null ? undefined : json['familyName'],
        'corporation': json['corporation'] == null ? undefined : json['corporation'],
        'admin': json['admin'] == null ? undefined : json['admin'],
        'organiser': json['organiser'] == null ? undefined : json['organiser'],
    };
}

export function UserDtoToJSON(json: any): UserDto {
    return UserDtoToJSONTyped(json, false);
}

export function UserDtoToJSONTyped(value?: UserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'givenName': value['givenName'],
        'familyName': value['familyName'],
        'corporation': value['corporation'],
        'admin': value['admin'],
        'organiser': value['organiser'],
    };
}

